module.exports = __webpack_public_path__ + "img/kickboxing.8f73d661.jpg";